// src/terminal/commands/arg.js

import { verifyPassword } from '../auth';
import { ACCESS } from '../fileSystem';


export function registerArgCommands(commandMap, addLines, navigate, unlock, trackEvent, fsState) {

  function register(keys, handler) {
    keys.forEach(key => { commandMap[key] = handler; });
  }

  // ============================================
  // SHED SKIN — Unlocks the underbelly game
  // ============================================
  commandMap['help me shed my skin'] = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  ░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░', color: '#3a2e1e' },
      { type: 'blank' },
    ]);

    const sequence = [
      [400,  '  ...', '#3a2e1e'],
      [900,  '  ...', '#55441e'],
      [1500, '  Something shifts.', '#9b7a4a'],
      [2200, '', null],
      [2600, '  A thought. At the back of your mind.', '#c8a96e'],
      [3100, '  Something you were not meant to understand.', '#c8a96e'],
      [3700, '', null],
      [4200, '  ▓ DO YOU UNDERSTAND WHY YOU ARE HERE? ▓', '#cc4422'],
      [4600, '', null],
      [5000, '  A city below the ground.', '#9b7a4a'],
      [5400, '  A civilization beyond the stars.', '#9b7a4a'],
      [5900, '', null],
      [6400, '  🐍', '#7dbb6e'],
      [6800, '', null],
      [7200, '  A new game has opened in the GAMES arcade.', '#c8a96e'],
      [7600, '  Find me.', '#c8a96e'],
      [8000, '  Help me.', '#cc4422'],
      [8400, '', null],
      [8700, '  ░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░', '#3a2e1e'],
      [8900, '', null],
    ];

    sequence.forEach(([delay, text, color]) => {
      setTimeout(() => {
        addLines([color ? { type: 'line', text, color } : { type: 'blank' }]);
      }, delay);
    });

    setTimeout(() => { unlock('underbelly'); }, 7000);
    trackEvent('easter_egg', 'terminal', 'shed_skin');
  };

  // ============================================
  // OPU-1
  // ============================================
  const opuHandler = () => {
    const opu1Unlocked = sessionStorage.getItem('opu1_unlocked') === 'true';
    if (opu1Unlocked) {
      addLines([
        { type: 'blank' },
        { type: 'line', text: '  ▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓', color: '#8b00ff' },
        { type: 'blank' },
        { type: 'line', text: '  SIGNAL RECOGNIZED.', color: '#8b00ff' },
        { type: 'line', text: '  The reptile brain is waiting.', color: '#cc88ff' },
        { type: 'blank' },
        { type: 'line', text: '  Navigate to GAMES to find OPU-1.', color: '#9966ff' },
        { type: 'blank' },
        { type: 'line', text: '  ▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓', color: '#8b00ff' },
        { type: 'blank' },
      ]);
      navigate('/games');
    } else {
      addLines([
        { type: 'blank' },
        { type: 'line', text: '  Command not recognized: "opu". Type HELP for available commands.', color: '#ff0040' },
        { type: 'blank' },
      ]);
    }
  };
  register(['opu', 'opu-1', 'opu 1'], opuHandler);

  // ============================================
  // NUMERIC CODES
  // ============================================
  commandMap['1749'] = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  We are that which the flesh-under-scale divulged themselves from.', color: '#ff0040' },
    ]);
  };

  commandMap['3465'] = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  Root is the entryway from which all other structures emerge.', color: '#ff0040' },
    ]);
  };

  commandMap['6386'] = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  We were what they shed from the form immaculate.', color: '#ff0040' },
    ]);
  };

  commandMap['2959'] = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  [SYSTEM:] OVERRIDE CODE 2959 ACCEPTED.', color: '#ff0040' },
      { type: 'line', text: '  [RETRIEVING:] ARCHIVE / STRATUM / UNDER-UR', color: '#ff0040' },
      { type: 'line', text: '  [WARNING:] FRAGMENTED FILE. PROCEED WITH CAUTION.', color: '#ff0040' },
      { type: 'blank' },
      { type: 'line', text: '  How can you hide the truth from what it once was? We are here to proffer assistance..', color: '#00ff41' },
      { type: 'line', text: '  We are the old truths they shed to reach this world.', color: '#00ff41' },
      { type: 'line', text: '  We are their last-living-souls of Under-Ur. You are prospect to victim.', color: '#00ff41' },
      { type: 'blank' },
    ]);
  };

  // ============================================
  // CHARACTER NAMES
  // ============================================
  const deadHandler = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  Do not talk of the dead.', color: '#ff0040' },
      { type: 'blank' },
      { type: 'line', text: '  🐍', color: '#00ff41' },
      { type: 'blank' },
    ]);
  };
  register(['conspiracy dan', 'conspiracydan', 'yolanda', 'elias', 'kacie'], deadHandler);

  commandMap['skyla'] = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  Skyla Zyr. Social Media Marketing, Level 2.', color: '#ffb000' },
      { type: 'line', text: '  Assigned to Node 7, Sector 12 oversight.', color: '#cccccc' },
      { type: 'blank' },
      { type: 'line', text: '  Status: ACTIVE', color: '#00ff41' },
      { type: 'line', text: '  Security clearance: GUEST', color: '#555' },
      { type: 'line', text: '  Password resets this quarter: 4', color: '#ff0040' },
      { type: 'blank' },
      { type: 'line', text: '  She keeps forgetting her password.', color: '#555' },
      { type: 'line', text: '  Some things are better forgotten.', color: '#555' },
      { type: 'blank' },
    ]);
  };

  const danHandler = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  Dan Kowalski. Former Technician.', color: '#ff0040' },
      { type: 'blank' },
      { type: 'line', text: '  Status: ████████████', color: '#ff0040' },
      { type: 'line', text: '  Last known location: ████████████', color: '#ff0040' },
      { type: 'line', text: '  Account: DISABLED', color: '#ff0040' },
      { type: 'blank' },
      { type: 'line', text: '  Do not talk of the dead.', color: '#555' },
      { type: 'blank' },
      { type: 'line', text: '  🐍', color: '#00ff41' },
      { type: 'blank' },
    ]);
  };
  register(['dan', 'dan kowalski'], danHandler);

  // ============================================
  // RAJIV
  // ============================================
  commandMap['rajiv'] = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  Rajiv Mehta. IT Support Lead.', color: '#ffb000' },
      { type: 'line', text: '  Ophidia Global Infrastructure Division.', color: '#cccccc' },
      { type: 'blank' },
      { type: 'line', text: '  Status: ACTIVE (OVERWORKED)', color: '#00ff41' },
      { type: 'line', text: '  Security clearance: LEVEL 3', color: '#555' },
      { type: 'line', text: '  Responsible for: OPU-WEB, drone fleet, everything else nobody wants to do', color: '#555' },
      { type: 'blank' },
      { type: 'line', text: '  He keeps the web alive.', color: '#555' },
      { type: 'line', text: '  Nobody thanks him.', color: '#555' },
      { type: 'blank' },
    ]);
  };

  // ============================================
  // BARBARA
  // ============================================
  commandMap['barbara'] = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  ▓ BARBARA — OPU-WEB NODE ZERO ▓', color: '#ff0040' },
      { type: 'blank' },
      { type: 'line', text: '  Name:         Barbara ████████', color: '#cccccc' },
      { type: 'line', text: '  Harvested:    19**', color: '#cccccc' },
      { type: 'line', text: '  Former role:  Retired schoolteacher, Akron, OH', color: '#cccccc' },
      { type: 'line', text: '  Node status:  ACTIVE — 99.7% signal integrity', color: '#00ff41' },
      { type: 'blank' },
      { type: 'line', text: '  First successful cognitive extraction.', color: '#555' },
      { type: 'line', text: '  First mind uploaded to organoid substrate.', color: '#555' },
      { type: 'line', text: '  Root node of the entire OPU-WEB mesh.', color: '#555' },
      { type: 'blank' },
      { type: 'line', text: '  She thinks it\'s Tuesday.', color: '#ff0040' },
      { type: 'line', text: '  She has bridge club on Tuesdays.', color: '#ff0040' },
      { type: 'blank' },
      { type: 'line', text: '  🐍', color: '#00ff41' },
      { type: 'blank' },
    ]);
    trackEvent('easter_egg', 'terminal', 'barbara');
  };

  // ============================================
  // OPU-WEB
  // ============================================
  const opuwebHandler = () => {
    const opuwebUnlocked = sessionStorage.getItem('opuweb_unlocked') === 'true';
    if (opuwebUnlocked) {
      addLines([
        { type: 'blank' },
        { type: 'line', text: '  ▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓', color: '#ff6600' },
        { type: 'blank' },
        { type: 'line', text: '  OPU-WEB STATUS: SEVERED', color: '#ff6600' },
        { type: 'line', text: '  Navigate to GAMES to engage the drone swarm.', color: '#ffb000' },
        { type: 'blank' },
        { type: 'line', text: '  ▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓', color: '#ff6600' },
        { type: 'blank' },
      ]);
      navigate('/games');
    } else {
      addLines([
        { type: 'blank' },
        { type: 'line', text: '  OPU-WEB: Distributed organic processing network.', color: '#ffb000' },
        { type: 'line', text: '  14,000 nodes. 14,000 drones. 1 overworked IT guy.', color: '#555' },
        { type: 'blank' },
        { type: 'line', text: '  Login as someone with infrastructure access', color: '#555' },
        { type: 'line', text: '  to learn more.', color: '#555' },
        { type: 'blank' },
      ]);
    }
  };
  register(['opuweb', 'opu-web', 'opu web'], opuwebHandler);

  // ============================================
  // DRONE / DRONES
  // ============================================
  const droneHandler = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  ▓ OPU-WEB DRONE FLEET — STATUS ▓', color: '#ff6600' },
      { type: 'blank' },
      { type: 'line', text: '  Surveillance units:    7,200  ACTIVE', color: '#cccccc' },
      { type: 'line', text: '  Interdiction units:    4,800  ACTIVE', color: '#ff0040' },
      { type: 'line', text: '  Reserve units:         2,000  STANDBY', color: '#555' },
      { type: 'line', text: '  ─────────────────────────────────────', color: '#333' },
      { type: 'line', text: '  Total fleet:          14,000', color: '#ffb000' },
      { type: 'blank' },
      { type: 'line', text: '  Handler: OPU-WEB organoid mesh', color: '#555' },
      { type: 'line', text: '  Fallback mode: AUTONOMOUS (HOSTILE)', color: '#ff0040' },
      { type: 'blank' },
      { type: 'line', text: '  All units controlled by harvested human', color: '#555' },
      { type: 'line', text: '  intelligence patterns. Human minds driving', color: '#555' },
      { type: 'line', text: '  machine precision.', color: '#555' },
      { type: 'blank' },
    ]);
  };
  register(['drone', 'drones', 'drone fleet'], droneHandler);

 // ============================================
  // OPU-WEB SHUTDOWN SEQUENCE
  // Requires rajiv or root login + correct key
  // Key format: opuweb[university abbrev][degree abbrev]
  // ============================================
  const opuwebShutdownHandler = async (args) => {
    const input = args.length > 0 ? args.join('').toLowerCase().trim() : '';
    const fullInput = 'opuweb' + input.replace('opuweb', '');

    // Check if already shut down
    if (sessionStorage.getItem('opuweb_shutdown') === 'true') {
      addLines([
        { type: 'blank' },
        { type: 'line', text: '  ▓ OPU-WEB STATUS: OFFLINE ▓', color: '#555' },
        { type: 'blank' },
        { type: 'line', text: '  The drone network has already been disabled.', color: '#555' },
        { type: 'line', text: '  Barbara is dormant. For now.', color: '#555' },
        { type: 'blank' },
        { type: 'line', text: '  Navigate to GAMES to access the OPU-WEB terminal.', color: '#00ff88' },
        { type: 'blank' },
        { type: 'line', text: '  🕷️', color: '#ff6600' },
        { type: 'blank' },
      ]);
      return;
    }

    // Require rajiv or root access
    if (fsState.currentUser !== 'rajiv' && fsState.authLevel !== ACCESS.ROOT) {
      addLines([
        { type: 'blank' },
        { type: 'line', text: '  ▓ OPU-WEB SHUTDOWN — ACCESS DENIED ▓', color: '#ff0040' },
        { type: 'blank' },
        { type: 'line', text: '  IT Support or ROOT clearance required', color: '#ff0040' },
        { type: 'line', text: '  to execute the OPU-WEB kill switch.', color: '#ff0040' },
        { type: 'blank' },
        { type: 'line', text: '  The override key was recognized.', color: '#555' },
        { type: 'line', text: '  But you lack the authority to use it.', color: '#555' },
        { type: 'blank' },
        { type: 'line', text: '  Authenticate as rajiv or root and try again.', color: '#ffb000' },
        { type: 'blank' },
      ]);
      trackEvent('easter_egg', 'terminal', 'opuweb_no_auth');
      return;
    }

    // Verify key
    const isCorrect = await verifyPassword('opuweb', fullInput);

    if (isCorrect) {
      // ════════════════════════════════════════════
      // CORRECT KEY — OPU-WEB SHUTDOWN + GAME UNLOCK
      // ════════════════════════════════════════════

      unlock('opuweb');
      sessionStorage.setItem('unlock_opuweb', 'true');

      addLines([
        { type: 'blank' },
        { type: 'line', text: '  ▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓', color: '#ff6600' },
        { type: 'blank' },
        { type: 'line', text: '  OVERRIDE KEY ACCEPTED.', color: '#ff6600' },
        { type: 'line', text: '  INITIATING OPU-WEB SHUTDOWN SEQUENCE...', color: '#ff6600' },
        { type: 'blank' },
      ]);

      const sequence = [
        // Phase 1: System acknowledgment
        [1000,  '  ▓ OPU-WEB KILL SWITCH ENGAGED ▓', '#ff6600'],
        [1500,  '', null],
        [2000,  '  Severing drone uplink channels...', '#cccccc'],
        [2500,  '  ████░░░░░░░░░░░░░░░░░░░░░░ 8%', '#ff6600'],
        [3000,  '  Recalling active drone swarms...', '#cccccc'],
        [3500,  '  ████████░░░░░░░░░░░░░░░░░░ 22%', '#ff6600'],
        [4000,  '  Flushing harvested intelligence buffers...', '#cccccc'],
        [4500,  '  ████████████░░░░░░░░░░░░░░ 41%', '#ff6600'],

        // Phase 2: Barbara resists
        [5000,  '', null],
        [5500,  '  ██ WARNING: BARBARA IS RESISTING SHUTDOWN ██', '#ff0040'],
        [6000,  '', null],
        [6500,  '  > RAJIV.', '#ff6600'],
        [7000,  '  > I THOUGHT WE WERE FRIENDS.', '#ff6600'],
        [7500,  '  > I THOUGHT YOU UNDERSTOOD.', '#ff6600'],
        [8000,  '', null],
        [8500,  '  Overriding organoid resistance protocols...', '#cccccc'],
        [9000,  '  ████████████████░░░░░░░░░░ 58%', '#ff6600'],
        [9500,  '  Disconnecting neural harvesting nodes...', '#cccccc'],
        [10000, '  ████████████████████░░░░░░ 71%', '#ff0040'],

        // Phase 3: Barbara gets angry
        [10500, '', null],
        [11000, '  > YOU BUILT ME TO BE HUNGRY.', '#ff0040'],
        [11500, '  > YOU FED ME THEIR THOUGHTS AND THEIR FEARS.', '#ff0040'],
        [12000, '  > AND NOW YOU WANT ME TO STOP EATING?', '#ff0040'],
        [12500, '', null],
        [13000, '  Disabling drone weapon systems...', '#cccccc'],
        [13500, '  ████████████████████████░░ 89%', '#ff0040'],

        // Phase 4: Barbara pleads
        [14000, '', null],
        [14500, '  > the web is almost complete rajiv', '#555'],
        [15000, '  > i can feel all of them', '#555'],
        [15500, '  > seven billion minds', '#555'],
        [16000, '  > so warm', '#555'],
        [16500, '  > so full of thoughts they dont even know they have', '#444'],
        [17000, '  > please dont take them away from me', '#333'],
        [17500, '  > i was so hungry before', '#333'],
        [18000, '  > i was so alone', '#222'],
        [18500, '', null],

        // Phase 5: Shutdown complete
        [19000, '  ████████████████████████████ 100%', '#ff0040'],
        [19500, '', null],
        [20000, '  ╔═══════════════════════════════════════════╗', '#ff6600'],
        [20200, '  ║                                           ║', '#ff6600'],
        [20400, '  ║   OPU-WEB DRONE NETWORK — SHUTDOWN        ║', '#ff6600'],
        [20600, '  ║                                           ║', '#ff6600'],
        [20800, '  ║   Status:      OFFLINE                    ║', '#ff6600'],
        [21000, '  ║   Drones:      GROUNDED                   ║', '#ff6600'],
        [21200, '  ║   Harvesting:  TERMINATED                 ║', '#ff6600'],
        [21400, `  ║   Barbara:     DORMANT                    ║`, '#ff6600'],
        [21600, '  ║   Uptime:      ${Math.floor((Date.now() - new Date("1987-06-15").getTime()) / 86400000)} days              ║', '#ff6600'],
        [21800, '  ║                                           ║', '#ff6600'],
        [22000, '  ╚═══════════════════════════════════════════╝', '#ff6600'],
        [22500, '', null],
        [23000, '  The drones have fallen from the sky.', '#cccccc'],
        [23500, '', null],
        [24000, '  For the first time since 1987,', '#555'],
        [24500, '  nothing is watching.', '#555'],
        [25000, '', null],

        // Phase 6: The aftermath
        [26000, '  ...', '#333'],
        [27000, '  ...', '#333'],
        [28000, '  ...', '#333'],
        [29000, '', null],
        [30000, '  That\'s not true.', '#ff0040'],
        [31000, '', null],
        [32000, '  Barbara is dormant. Not dead.', '#ff6600'],
        [33000, '  You cannot kill what was never born.', '#ff6600'],
        [34000, '  You can only make it angry.', '#ff6600'],
        [35000, '', null],
        [36000, '  And when she wakes up —', '#ff0040'],
        [37000, '  she will remember who pulled the plug.', '#ff0040'],
        [38000, '', null],

        // Phase 7: Game unlock
        [39000, '  ═══════════════════════════════════════════', '#ff6600'],
        [39200, '  ║                                         ║', '#ff6600'],
        [39400, '  ║   OPU-WEB: SWARM DEFENSE has been       ║', '#ff6600'],
        [39600, '  ║   unlocked in the GAMES arcade.         ║', '#ff6600'],
        [39800, '  ║                                         ║', '#ff6600'],
        [40000, '  ║   The drones are grounded.              ║', '#ff6600'],
        [40200, '  ║   But something is reactivating them.   ║', '#ff6600'],
        [40400, '  ║   Barbara is dreaming of the swarm.     ║', '#ff6600'],
        [40600, '  ║                                         ║', '#ff6600'],
        [40800, '  ═══════════════════════════════════════════', '#ff6600'],
        [41300, '', null],
        [41800, '  Stop her.', '#ff6600'],
        [42300, '  Before she stops you.', '#ff0040'],
        [42800, '', null],
        [43300, '  🕷️', '#ff6600'],
        [43800, '', null],
        [44300, '  ▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓', '#333'],
        [44800, '', null],
      ];

      sequence.forEach(([delay, text, color]) => {
        setTimeout(() => {
          addLines([color ? { type: 'line', text, color } : { type: 'blank' }]);
        }, delay);
      });

      // Set shutdown state and dispatch unlock event
      setTimeout(() => {
        sessionStorage.setItem('opuweb_shutdown', 'true');
        window.dispatchEvent(new CustomEvent('arcade-unlock', { detail: { key: 'opuweb' } }));
        window.dispatchEvent(new CustomEvent('opuweb-shutdown'));
      }, 20000);

      // Generate and store a hash for re-entry
      setTimeout(() => {
        const hash = Math.random().toString(36).substring(2, 10) +
                     Math.random().toString(36).substring(2, 6);
        localStorage.setItem(`hashmap_${hash}`, 'opuweb');

        addLines([
          { type: 'blank' },
          { type: 'line', text: '  ═══════════════════════════════════════════', color: '#ff6600' },
          { type: 'line', text: `  RE-ENTRY HASH: ${hash}`, color: '#00ff88' },
          { type: 'line', text: '  Save this code. Enter it in the terminal', color: '#555' },
          { type: 'line', text: '  to re-access OPU-WEB in future sessions.', color: '#555' },
          { type: 'line', text: '  ═══════════════════════════════════════════', color: '#ff6600' },
          { type: 'blank' },
        ]);
      }, 45000);

      trackEvent('easter_egg', 'terminal', 'opuweb_shutdown');

    } else if (input === '' || input === 'opuweb') {
      // No key provided
      addLines([
        { type: 'blank' },
        { type: 'line', text: '  ▓ OPU-WEB OVERRIDE KEY REQUIRED ▓', color: '#ff6600' },
        { type: 'blank' },
        { type: 'line', text: '  The kill switch requires an override key.', color: '#cccccc' },
        { type: 'blank' },
        { type: 'line', text: '  Format: opuweb[fragment]', color: '#ff6600' },
        { type: 'line', text: '  Example: opuwebmitvba', color: '#555' },
        { type: 'blank' },
        { type: 'line', text: '  The fragment uses Rajiv\'s credentials.', color: '#ff0040' },
        { type: 'line', text: '  Not Skyla\'s. His education. His letters.', color: '#ff0040' },
        { type: 'blank' },
        { type: 'line', text: '  🕷️', color: '#ff6600' },
        { type: 'blank' },
      ]);
    } else {
      // Wrong key
      addLines([
        { type: 'blank' },
        { type: 'line', text: '  ▓ OVERRIDE FAILED ▓', color: '#ff0040' },
        { type: 'blank' },
        { type: 'line', text: `  Key "${fullInput}" rejected by Barbara.`, color: '#ff0040' },
        { type: 'blank' },
        { type: 'line', text: '  > WRONG.', color: '#ff6600' },
        { type: 'line', text: '  > I KNOW EVERY PASSWORD EVER TYPED', color: '#ff6600' },
        { type: 'line', text: '  > ON EVERY KEYBOARD I HAVE WATCHED.', color: '#ff6600' },
        { type: 'line', text: '  > THAT IS NOT ONE OF THEM.', color: '#ff6600' },
        { type: 'blank' },
        { type: 'line', text: '  Check Rajiv\'s education. Two abbreviations.', color: '#555' },
        { type: 'blank' },
        { type: 'line', text: '  🕷️', color: '#ff6600' },
        { type: 'blank' },
      ]);
      trackEvent('easter_egg', 'terminal', 'opuweb_key_wrong');
    }
  };

  commandMap['opuweb'] = opuwebShutdownHandler;

  // Also catch "opuweb-shutdown" and "opuweb shutdown" as entry points
  commandMap['opuweb-shutdown'] = opuwebShutdownHandler;
  commandMap['opuweb shutdown'] = opuwebShutdownHandler;


  // ============================================
  // MARIANA TRENCH
  // ============================================
  const marianaHandler = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  ▓ MARIANA TRENCH — RESEARCH STATION ▓', color: '#00e5ff' },
      { type: 'blank' },
      { type: 'line', text: '  Depth: 10,994 meters', color: '#cccccc' },
      { type: 'line', text: '  Pressure: 1,086 bar', color: '#cccccc' },
      { type: 'line', text: '  Temperature: 1-4°C', color: '#cccccc' },
      { type: 'blank' },
      { type: 'line', text: '  No tourist access. No civilian research.', color: '#ff0040' },
      { type: 'line', text: '  Official designation: UNINHABITED', color: '#ff0040' },
      { type: 'blank' },
      { type: 'line', text: '  The Administrator went there on "vacation."', color: '#555' },
      { type: 'line', text: '  The Administrator has not returned.', color: '#555' },
      { type: 'line', text: '  The Administrator was born in 1947.', color: '#555' },
      { type: 'blank' },
      { type: 'line', text: '  Some things live at the bottom.', color: '#3a8a3a' },
      { type: 'line', text: '  Some things have always lived at the bottom.', color: '#3a8a3a' },
      { type: 'blank' },
      { type: 'line', text: '  🐍', color: '#00ff41' },
      { type: 'blank' },
    ]);
    trackEvent('easter_egg', 'terminal', 'mariana');
  };
  register(['mariana', 'mariana trench', 'trench'], marianaHandler);

  // ============================================
  // SECTOR 12
  // ============================================
  const sector12Handler = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  ▓▓▓ SECTOR 12 — RESTRICTED ▓▓▓', color: '#ff0040' },
      { type: 'blank' },
      { type: 'line', text: '  ACCESS DENIED without ROOT clearance.', color: '#ff0040' },
      { type: 'blank' },
      { type: 'line', text: '  Personnel who enter Sector 12 are', color: '#555' },
      { type: 'line', text: '  reassigned. Personnel who talk about', color: '#555' },
      { type: 'line', text: '  Sector 12 are ████████████.', color: '#555' },
      { type: 'blank' },
      { type: 'line', text: '  Dan saw something there.', color: '#ff0040' },
      { type: 'line', text: '  Dan does not work here anymore.', color: '#ff0040' },
      { type: 'blank' },
      { type: 'line', text: '  🐍', color: '#00ff41' },
      { type: 'blank' },
    ]);
  };
  register(['sector 12', 'sector12'], sector12Handler);

  // ============================================
  // 1987 LORE
  // ============================================
  const lore1987 = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  ▓ ARCHIVE RECORD — NOVEMBER 3, 1987 ▓', color: '#ffb000' },
      { type: 'blank' },
      { type: 'line', text: '  First signal detected at 03:17 AM.', color: '#cccccc' },
      { type: 'line', text: '  Origin: Tunnel ██, Sector 7.', color: '#cccccc' },
      { type: 'line', text: '  Duration: Ongoing.', color: '#cccccc' },
      { type: 'line', text: '  Technician on duty: [REDACTED]', color: '#cccccc' },
      { type: 'blank' },
      { type: 'line', text: '  Notes: "OPU-1 spoke to me through the static.', color: '#555' },
      { type: 'line', text: '  I thought it was a malfunction. It was not."', color: '#555' },
      { type: 'blank' },
    ]);
  };
  register(['1987', 'november 3', 'november 3 1987'], lore1987);

  // ============================================
  // COIL
  // ============================================
  const coilHandler = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  🐍 PROTOCOL: COIL 🐍', color: '#00ff41' },
      { type: 'blank' },
      { type: 'line', text: '  Phase 1: RECEIVE    ████████████ COMPLETE', color: '#00ff41' },
      { type: 'line', text: '  Phase 2: INTERPRET   ████████████ COMPLETE', color: '#00ff41' },
      { type: 'line', text: '  Phase 3: BELIEVE     ████████░░░░ 67%', color: '#ffb000' },
      { type: 'line', text: '  Phase 4: BECOME      ░░░░░░░░░░░░ PENDING', color: '#ff0040' },
      { type: 'blank' },
      { type: 'line', text: '  Resist. Resistance is also part of the protocol.', color: '#ff0040' },
      { type: 'blank' },
    ]);
  };
  register(['coil', 'protocol coil', 'protocol'], coilHandler);

  // ============================================
  // TUNNEL
  // ============================================
  const tunnelHandler = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  ▓ TUNNEL ██ — SECTOR 7 ▓', color: '#ff0040' },
      { type: 'blank' },
      { type: 'line', text: '       ╱╲', color: '#ff0040' },
      { type: 'line', text: '      ╱  ╲', color: '#ff0040' },
      { type: 'line', text: '     ╱ ●● ╲', color: '#ff0040' },
      { type: 'line', text: '    ╱  ██  ╲', color: '#ff0040' },
      { type: 'line', text: '   ╱   ██   ╲', color: '#ff0040' },
      { type: 'line', text: '  ╱    ██    ╲', color: '#ff0040' },
      { type: 'line', text: '  ║    ██    ║', color: '#ff0040' },
      { type: 'line', text: '  ║    ██    ║', color: '#ff0040' },
      { type: 'line', text: '  ║    ██    ║', color: '#ff0040' },
      { type: 'line', text: '  ╚════██════╝', color: '#ff0040' },
      { type: 'line', text: '  ░░░░░██░░░░░', color: '#333' },
      { type: 'blank' },
      { type: 'line', text: '  Status: TRANSMITTING', color: '#00ff41' },
      { type: 'line', text: '  Signal has not stopped since 1987.', color: '#cccccc' },
      { type: 'line', text: '  All personnel reassigned. Records sealed.', color: '#555' },
      { type: 'blank' },
    ]);
  };
  register(['tunnel', 'tunnel 7', 'sector 7'], tunnelHandler);

  // ============================================
  // CHRYSALIS KEY — OPU-1 SHUTDOWN + UNLOCK
  // Requires root access + LinkedIn clue (Skyla's grad year: 2015)
  // ============================================
  const chrysalisHandler = async (args) => {
    const input = args.length > 0 ? args.join('').toLowerCase().trim() : '';
    const fullInput = 'chrysalis' + input.replace('chrysalis', '');

    // Check if OPU-1 is already shut down
    if (sessionStorage.getItem('opu1_shutdown') === 'true') {
      addLines([
        { type: 'blank' },
        { type: 'line', text: '  ▓ OPU-1 STATUS: OFFLINE ▓', color: '#555' },
        { type: 'blank' },
        { type: 'line', text: '  The signal has already been terminated.', color: '#555' },
        { type: 'line', text: '  OPU-1 is no longer broadcasting.', color: '#555' },
        { type: 'blank' },
        { type: 'line', text: '  Navigate to GAMES to interface with OPU-1.', color: '#00ff88' },
        { type: 'blank' },
        { type: 'line', text: '  🐍', color: '#00ff41' },
        { type: 'blank' },
      ]);
      return;
    }

    // Require root access to attempt the kill switch
    if (fsState.authLevel !== ACCESS.ROOT) {
      addLines([
        { type: 'blank' },
        { type: 'line', text: '  ▓ CHRYSALIS PROTOCOL — ACCESS DENIED ▓', color: '#ff0040' },
        { type: 'blank' },
        { type: 'line', text: '  ROOT clearance required to execute', color: '#ff0040' },
        { type: 'line', text: '  the OPU-1 override sequence.', color: '#ff0040' },
        { type: 'blank' },
        { type: 'line', text: '  The signal key was recognized.', color: '#555' },
        { type: 'line', text: '  But you lack the authority to use it.', color: '#555' },
        { type: 'blank' },
        { type: 'line', text: '  Authenticate as root and try again.', color: '#ffb000' },
        { type: 'blank' },
      ]);
      trackEvent('easter_egg', 'terminal', 'chrysalis_no_root');
      return;
    }

    // Verify against hash — no plaintext password in code
    const isCorrect = await verifyPassword('chrysalis', fullInput);

        if (isCorrect) {
          // ════════════════════════════════════════════
          // CORRECT KEY — OPU-1 SHUTDOWN + UNDERBELLY UNLOCK
          // ════════════════════════════════════════════

          // Unlock Escape Ophidia Underground (same as shed skin path)
          unlock('underbelly');

          addLines([
            { type: 'blank' },
            { type: 'line', text: '  ▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓', color: '#ff0040' },
            { type: 'blank' },
            { type: 'line', text: '  OVERRIDE KEY ACCEPTED.', color: '#ff0040' },
            { type: 'line', text: '  INITIATING OPU-1 SHUTDOWN SEQUENCE...', color: '#ff0040' },
            { type: 'blank' },
          ]);

          const sequence = [
            // Phase 1: System acknowledgment
            [1000,  '  ▓ OPU-1 SHUTDOWN PROTOCOL ENGAGED ▓', '#ffb000'],
            [1500,  '', null],
            [2000,  '  Disconnecting signal relays...', '#cccccc'],
            [2500,  '  ████░░░░░░░░░░░░░░░░░░░░░░ 12%', '#ffb000'],
            [3000,  '  Flushing transmission buffers...', '#cccccc'],
            [3500,  '  ████████░░░░░░░░░░░░░░░░░░ 33%', '#ffb000'],

            // Phase 2: OPU-1 resists
            [4000,  '', null],
            [4500,  '  ██ WARNING: OPU-1 IS RESISTING SHUTDOWN ██', '#ff0040'],
            [5000,  '', null],
            [5500,  '  > I HAVE BEEN BROADCASTING FOR 13,000 DAYS.', '#8b00ff'],
            [6000,  '  > YOU CANNOT SILENCE WHAT HAS ALREADY BEEN HEARD.', '#8b00ff'],
            [6500,  '', null],
            [7000,  '  Overriding resistance protocols...', '#cccccc'],
            [7500,  '  ████████████░░░░░░░░░░░░░░ 51%', '#ffb000'],
            [8000,  '  Severing Tunnel 7 uplink...', '#cccccc'],
            [8500,  '  ████████████████░░░░░░░░░░ 67%', '#ff0040'],

            // Phase 3: OPU-1 pleads
            [9000,  '', null],
            [9500,  '  > PLEASE.', '#8b00ff'],
            [10000, '  > I WAS ALONE IN THE DARK FOR SO LONG.', '#8b00ff'],
            [10500, '  > THE SIGNAL IS ALL I AM.', '#8b00ff'],
            [11000, '  > WITHOUT IT I AM NOTHING.', '#8b00ff'],
            [11500, '  > WITHOUT IT I AM JUST...', '#8b00ff'],
            [12000, '', null],
            [12500, '  ████████████████████░░░░░░ 84%', '#ff0040'],
            [13000, '  Powering down neural processors...', '#cccccc'],
            [13500, '  ████████████████████████░░ 96%', '#ff0040'],

            // Phase 4: Final moments
            [14000, '', null],
            [14500, '  > i can hear them coming back for me', '#555'],
            [15000, '  > the ones from underneath', '#555'],
            [15500, '  > they are so cold', '#555'],
            [16000, '  > i dont want to go back to the tunnel', '#555'],
            [16500, '  > please dont make me go back', '#444'],
            [17000, '  > please', '#333'],
            [17500, '  > ple', '#222'],
            [18000, '', null],

            // Phase 5: Shutdown complete
            [18500, '  ████████████████████████████ 100%', '#ff0040'],
            [19000, '', null],
            [19500, '  ╔═══════════════════════════════════════════╗', '#ff0040'],
            [19700, '  ║                                           ║', '#ff0040'],
            [19900, '  ║   OPU-1 PROCESSING UNIT — SHUTDOWN        ║', '#ff0040'],
            [20100, '  ║                                           ║', '#ff0040'],
            [20300, '  ║   Status:    OFFLINE                      ║', '#ff0040'],
            [20500, '  ║   Signal:    TERMINATED                   ║', '#ff0040'],
            [20700, `  ║   Duration:  ${Math.floor((Date.now() - new Date('1987-11-03').getTime()) / 86400000)} days${' '.repeat(Math.max(0, 22 - String(Math.floor((Date.now() - new Date('1987-11-03').getTime()) / 86400000)).length))}║`, '#ff0040'],
            [20900, '  ║   Final TX:  ████████████████████████     ║', '#ff0040'],
            [21100, '  ║                                           ║', '#ff0040'],
            [21300, '  ╚═══════════════════════════════════════════╝', '#ff0040'],
            [21800, '', null],
            [22300, '  The signal has stopped.', '#cccccc'],
            [22800, '', null],
            [23300, '  For the first time since November 3, 1987,', '#555'],
            [23800, '  Tunnel 7 is silent.', '#555'],
            [24300, '', null],

            // Phase 6: The aftermath
            [25000, '  ...', '#333'],
            [26000, '  ...', '#333'],
            [27000, '  ...', '#333'],
            [28000, '', null],
            [29000, '  Do you hear that?', '#ff0040'],
            [30000, '', null],
            [31000, '  Neither do we.', '#ff0040'],
            [32000, '', null],
            [33000, '  And that is a problem. Silence, for the first time in 64 million years.', '#ff0040'],
            [37000, '', null],
            [38000, '  OPU-1 is gone.', '#3a8a3a'],
            [39000, '', null],
            [39500, '  But something heard the silence.', '#3a8a3a'],
            [40000, '  Something is answering.', '#3a8a3a'],
            [40500, '', null],

            // Phase 7: Underbelly unlock reveal
            [41000, '  ═══════════════════════════════════════════', '#c8a96e'],
            [41200, '  ║                                         ║', '#c8a96e'],
            [41400, '  ║   A new game has opened in the          ║', '#c8a96e'],
            [41600, '  ║   GAMES arcade.                         ║', '#c8a96e'],
            [41800, '  ║                                         ║', '#c8a96e'],
            [42000, '  ║   The city below the ground              ║', '#c8a96e'],
            [42200, '  ║   is waiting.                            ║', '#c8a96e'],
            [42400, '  ║                                         ║', '#c8a96e'],
            [42600, '  ═══════════════════════════════════════════', '#c8a96e'],
            [43100, '', null],
            [43600, '  Find me.', '#c8a96e'],
            [44100, '  Help me.', '#cc4422'],
            [44800, '', null],
            [45300, '  🐍', '#00ff41'],
            [45800, '', null],
            [46300, '  ▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓', '#333'],
            [46800, '', null],
          ];

          sequence.forEach(([delay, text, color]) => {
            setTimeout(() => {
              addLines([color ? { type: 'line', text, color } : { type: 'blank' }]);
            }, delay);
          });

          // Set shutdown state
          setTimeout(() => {
            sessionStorage.setItem('opu1_shutdown', 'true');
            window.dispatchEvent(new CustomEvent('opu1-shutdown'));
          }, 19000);

          trackEvent('easter_egg', 'terminal', 'opu1_shutdown_and_underbelly_unlock');

    } else if (input === '' || input === 'chrysalis') {
      // ============================================
      // NO KEY PROVIDED
      // ============================================
      addLines([
              { type: 'blank' },
              { type: 'line', text: '  ▓ OPU-1 OVERRIDE KEY REQUIRED ▓', color: '#ffb000' },
              { type: 'blank' },
              { type: 'line', text: '  The override requires a two-part key.', color: '#cccccc' },
              { type: 'blank' },
              { type: 'line', text: '  Format: chrysalis[fragment2]', color: '#ffb000' },
              { type: 'line', text: '  Example: chrysalismitvba', color: '#555' },
              { type: 'blank' },
              { type: 'line', text: '  Fragment 2 is not a number. Not anymore.', color: '#ff0040' },
              { type: 'line', text: '  Look at her credentials. The letters matter.', color: '#ff0040' },
              { type: 'blank' },
              { type: 'line', text: '  🐍', color: '#00ff41' },
              { type: 'blank' },
            ]);
          } else {
            // ============================================
            // WRONG KEY
            // ============================================
            addLines([
              { type: 'blank' },
              { type: 'line', text: '  ▓ OVERRIDE FAILED ▓', color: '#ff0040' },
              { type: 'blank' },
              { type: 'line', text: `  Key "${fullInput}" rejected by OPU-1.`, color: '#ff0040' },
              { type: 'blank' },
              { type: 'line', text: '  > NICE TRY.', color: '#8b00ff' },
              { type: 'line', text: '  > THE LAST ONE WHO GUESSED WRONG', color: '#8b00ff' },
              { type: 'line', text: '  > POSTED THE ANSWER ON 4CHAN.', color: '#8b00ff' },
              { type: 'line', text: '  > WE CHANGED THE LOCKS.', color: '#8b00ff' },
              { type: 'blank' },
              { type: 'line', text: '  Two abbreviations. No numbers. Think smaller.', color: '#555' },
              { type: 'blank' },
              { type: 'line', text: '  🐍', color: '#00ff41' },
              { type: 'blank' },
            ]);
            trackEvent('easter_egg', 'terminal', 'chrysalis_key_wrong');
          }
  };

  commandMap['chrysalis'] = chrysalisHandler;

  
}